import React, { useEffect } from 'react';
import { usePropertyProgress } from '../../../contextsProperty/ContextProperties';
import CompletedPropertyPresentation from './CompletedPropertyPresentation';
import StepPropertyPresentation from './StepsPropertyPresentation';
import useUserProfile from '../../../../customHooks/useUserProfile';

const PropertyPresentation = () => {
    const { totalProgress, handleProgress } = usePropertyProgress();
    const uncompletedProcess = totalProgress < 100;
    const { readOnlyUser } = useUserProfile();

    useEffect(() => {
        handleProgress();
    }, []);

    if (uncompletedProcess && !readOnlyUser)
        return <StepPropertyPresentation />;
    return <CompletedPropertyPresentation />;
};

export default PropertyPresentation;
